import React, { useEffect } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
import InfoContainer from "../../../../components/InfoContainer";
import "./IndustrialChemicals.css";
export default function IndustrialChemicals() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Industrial Chemicals"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      ></Breadcrumb>
      <InfoContainer
        title="Quality Chemicals for Diverse Industries"
        paragraph1="We offer a comprehensive range of Industrial Chemicals for various sectors, including manufacturing, agriculture, automotive, and textiles. Our products are sourced from leading global suppliers and cover a wide spectrum, including petrochemicals, polymers, solvents, adhesives, and agrochemicals."
        paragraph2="Our industrial chemicals are essential for the production of everything from plastics and paints to fertilizers and rubber. We work closely with our clients to deliver the right products that meet the unique demands of their industry. With a focus on quality, sustainability, and compliance, we ensure that every chemical we supply adheres to the strictest safety and regulatory standards."
      />
    </>
  );
}
